import urlJoin from 'url-join';

export const WpDpApi = {
	baseURL: urlJoin(window.dpIntroTourPublicConfig.restApiUrl, 'dpintrotours/v1/'),
	headers: { 'X-WP-Nonce': window.dpIntroTourPublicConfig.nonces.wp_rest_nonce },
	params: { builder_api_key: window.dpIntroTourPublicConfig.nonces.builder_api_key },
};

export const DpServerApi = {
	baseURL: urlJoin(window.dpIntroTourPublicConfig.ratingFeedbackLink),
};
